import React, { FC } from 'react';
import { Form, redirectTo } from 'omni-package-react-core';
import { useTranslation } from 'react-i18next';
import { useScopedSelector } from 'ia-react-core';
import { useNavigate } from 'react-router-dom';
import getPreferencesApiRoot from '../../../utils/getPreferencesApiRoot';
import { CommunicationPreferencesFormPageState } from '../../../interfaces/CommunicationPreferencesFormPageState';
import DocumentPreferencesSection from './DocumentPreferencesSection/DocumentPreferencesSection';
import CommunicationPreferencesSection from './CommunicationPreferencesSection/CommunicationPreferencesSection';
import TermsOfUseSection from './TermsOfUseSection/TermsOfUseSection';
import { DocumentPreference } from '../../../interfaces/DocumentPreference';
import { CommunicationPreferences } from '../../../interfaces/CommunicationPreferences';
import Constants from '../../../Constants';

export interface CommunicationPreferencesFormProps { }

const CommunicationPreferencesForm: FC<CommunicationPreferencesFormProps> = () => {
  const { t } = useTranslation('CommunicationPreferencesFormPage');
  const navigate = useNavigate();
  const formState = useScopedSelector((state: CommunicationPreferencesFormPageState) => state);

  const buildPayload = (values: CommunicationPreferences) => (
    {
      isSubscribedToDocumentNotification: values.isSubscribedToDocumentNotification,
      communicationPreference: {
        id: values.communicationPreference.id || 1,
        preferenceValue: values.communicationPreference.preferenceValue,
      },
      documentPreferences: values.documentPreferences.filter((x: DocumentPreference) => x),
    });

  if (!formState?.current?.hasAccess) {
    setTimeout(() => { redirectTo('/unauthorized', navigate); });
    return null;
  }

  return (
    <Form<CommunicationPreferences, CommunicationPreferences>
      name="preferencesForm"
      url={getPreferencesApiRoot()}
      createMethod="PUT"
      transformRequest={(values: CommunicationPreferences) => buildPayload(values)}
      infoMessageText={t('informationsLabel')}
      confirmationPath={Constants.PreferencesCommunicationChangeConfirmationPath}
    >
      <DocumentPreferencesSection
        preferences={formState.current.documentPreferences}
        isSubscribedToDocumentNotification={formState.current.isSubscribedToDocumentNotification}
      />
      <CommunicationPreferencesSection
        preference={formState.current.communicationPreference}
      />
      <TermsOfUseSection />
    </Form>
  );
};

export default CommunicationPreferencesForm;
